import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]
  static values = { 
    url: String,
    category: String,
    subcategory: String
  }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: '.drag-handle',
      animation: 150,
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      onStart: this.onStart.bind(this),
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onStart(event) {
    // ドラッグ開始時の処理
    event.item.classList.add('dragging')
    document.body.style.cursor = 'grabbing'
  }

  onEnd(event) {
    // ドラッグ終了時の処理
    event.item.classList.remove('dragging')
    document.body.style.cursor = ''

    // 位置が変更された場合のみ更新
    if (event.oldIndex !== event.newIndex) {
      this.updatePosition(event)
    }
  }

  async updatePosition(event) {
    const productId = event.item.dataset.productId
    const newPosition = event.newIndex + 1 // 1-based indexing
    
    try {
      // 楽観的更新: UIは既に更新されている
      const response = await fetch(`${this.urlValue}/${productId}/move_to_position`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken(),
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          position: newPosition,
          category: this.categoryValue,
          subcategory: this.subcategoryValue
        })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      
      if (result.success) {
        this.showSuccessMessage('並び順を更新しました')
      } else {
        throw new Error(result.error || '更新に失敗しました')
      }

    } catch (error) {
      console.error('Position update failed:', error)
      this.showErrorMessage('並び順の更新に失敗しました')
      
      // エラー時は元の位置に戻す
      this.revertPosition(event)
    }
  }

  revertPosition(event) {
    // 元の位置に戻す
    const items = Array.from(this.listTarget.children)
    const item = event.item
    
    // 元の位置を計算
    if (event.oldIndex < event.newIndex) {
      // 下に移動していた場合
      const nextSibling = items[event.oldIndex]
      this.listTarget.insertBefore(item, nextSibling)
    } else {
      // 上に移動していた場合
      const nextSibling = items[event.oldIndex + 1]
      this.listTarget.insertBefore(item, nextSibling)
    }
  }

  updatePositionNumbers() {
    // 位置番号の表示を更新
    const items = this.listTarget.querySelectorAll('[data-product-id]')
    items.forEach((item, index) => {
      const positionElement = item.querySelector('.position-number')
      if (positionElement) {
        positionElement.textContent = `位置: ${index + 1}`
      }
    })
  }

  showSuccessMessage(message) {
    this.showFlashMessage(message, 'success')
  }

  showErrorMessage(message) {
    this.showFlashMessage(message, 'error')
  }

  showFlashMessage(message, type) {
    // 既存のフラッシュメッセージがあれば削除
    const existingFlash = document.querySelector('.flash-message')
    if (existingFlash) {
      existingFlash.remove()
    }

    // 新しいフラッシュメッセージを作成
    const flashDiv = document.createElement('div')
    flashDiv.className = `flash-message fixed top-4 right-4 z-50 px-4 py-2 rounded-md shadow-lg ${
      type === 'success' 
        ? 'bg-green-500 text-white' 
        : 'bg-red-500 text-white'
    }`
    flashDiv.textContent = message

    document.body.appendChild(flashDiv)

    // 3秒後に自動削除
    setTimeout(() => {
      if (flashDiv.parentNode) {
        flashDiv.remove()
      }
    }, 3000)
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }
}
